__turbopack_context__.v({
  "benefitsTitle": "smallStyles-module-scss-module__eF6eta__benefitsTitle",
  "button": "smallStyles-module-scss-module__eF6eta__button",
  "coins": "smallStyles-module-scss-module__eF6eta__coins",
  "col": "smallStyles-module-scss-module__eF6eta__col",
  "content": "smallStyles-module-scss-module__eF6eta__content",
  "currencyIcon": "smallStyles-module-scss-module__eF6eta__currencyIcon",
  "disabledText": "smallStyles-module-scss-module__eF6eta__disabledText",
  "footer": "smallStyles-module-scss-module__eF6eta__footer",
  "freeSpins": "smallStyles-module-scss-module__eF6eta__freeSpins",
  "goldenKey": "smallStyles-module-scss-module__eF6eta__goldenKey",
  "icon": "smallStyles-module-scss-module__eF6eta__icon",
  "insufficientCoin": "smallStyles-module-scss-module__eF6eta__insufficientCoin",
  "insufficientContent": "smallStyles-module-scss-module__eF6eta__insufficientContent",
  "insufficientFundsWrapper": "smallStyles-module-scss-module__eF6eta__insufficientFundsWrapper",
  "newCount": "smallStyles-module-scss-module__eF6eta__newCount",
  "oldCount": "smallStyles-module-scss-module__eF6eta__oldCount",
  "points": "smallStyles-module-scss-module__eF6eta__points",
  "root": "smallStyles-module-scss-module__eF6eta__root",
  "scBlockUnderGC": "smallStyles-module-scss-module__eF6eta__scBlockUnderGC",
  "sweepBonus": "smallStyles-module-scss-module__eF6eta__sweepBonus",
  "sweepBonusValue": "smallStyles-module-scss-module__eF6eta__sweepBonusValue",
  "sweepBonusValueColumn": "smallStyles-module-scss-module__eF6eta__sweepBonusValueColumn",
  "vipCoin": "smallStyles-module-scss-module__eF6eta__vipCoin",
  "vipCoinValue": "smallStyles-module-scss-module__eF6eta__vipCoinValue",
});
